module.exports = __webpack_public_path__ + "images/canonical-comment/forward-icon.12c68c5ab81a8e510455.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-comment/forward-icon.svg
// module id = YG2K
// module chunks = 2